module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNS41OSAxMC41OEwxLjQyIDYuNDEgMCA3LjgybDUuNTkgNS41OSAxMi0xMkwxNi4xOCAwIDUuNTkgMTAuNTh6IiBmaWxsPSIjRjJCNTI2Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./assets/svgs/yellow-tick.svg
// module id = 1611
// module chunks = 0